/**
 * The Games tab's deep links (the Website hub's Game Lists card): `add` when `?add=list` (open the list editor in
 * create mode), `manage` when `?manage=1` (open Reorder lists); and the search string with both parameters removed,
 * whatever their values, which the tab writes back (history replace) once it has acted on them, so a reload never
 * reopens a sheet. `''` when nothing remains.
 */
export const gamesDeepLink = (search: string): { add: boolean; manage: boolean; search: string } => {
  const params = new URLSearchParams(search);
  const add = params.get('add') === 'list';
  const manage = params.get('manage') === '1';
  if (!params.has('add') && !params.has('manage')) return { add, manage, search };
  params.delete('add');
  params.delete('manage');
  const rest = params.toString();
  return { add, manage, search: rest ? `?${rest}` : '' };
};
